<template>
    <div class="pad-bottom--xl">
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12">
                        <h1 class="pad-top--xl pad-bottom--xl z-up text-white">
                            {{ userName }} - My Orders
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x border-bottom pad-top pad-bottom--xl">
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-profile"
                        class="h4 text-light-grey">
                        My Profile
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-orders"
                        class="h4">
                        My Orders
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-designs"
                        class="h4 text-light-grey">
                        My Designs
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-favourites"
                        class="h4 text-light-grey">
                        My Favourites
                    </router-link>
                </div>
            </div>
            <div
                v-for="(order, index) in orders"
                v-bind:key="index"
                class="grid-x grid-padding-x pad-top">
                <div class="cell small-12 medium-8 medium-offset-2">
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-3">
                            <p>
                                Order number: {{ order.id }}<br />
                                Total: &pound; {{ order.amount }}
                            </p>
                        </div>
                        <div class="cell small-12 medium-3">
                            <p>
                                Invoice address:<br />
                                <span v-if="order.invoice_address.line_one">
                                    {{ order.invoice_address.line_one }}<br />
                                </span>
                                <span v-if="order.invoice_address.line_two">
                                    {{ order.invoice_address.line_two }}<br />
                                </span>
                                <span v-if="order.invoice_address.town">
                                    {{ order.invoice_address.town }}<br />
                                </span>
                                <span v-if="order.invoice_address.postcode">
                                    {{ order.invoice_address.postcode }}<br />
                                </span>
                            </p>
                        </div>
                        <div class="cell small-12 medium-3">
                            <p>
                                Delivery address:<br />
                                <span v-if="order.delivery_address.line_one">
                                    {{ order.delivery_address.line_one }}<br />
                                </span>
                                <span v-if="order.delivery_address.line_two">
                                    {{ order.delivery_address.line_two }}<br />
                                </span>
                                <span v-if="order.delivery_address.town">
                                    {{ order.delivery_address.town }}<br />
                                </span>
                                <span v-if="order.delivery_address.postcode">
                                    {{ order.delivery_address.postcode }}<br />
                                </span>
                            </p>
                        </div>
                        <div class="cell small-12 medium-3">
                            <p>Order items:</p>
                            <div
                                v-for="(item, itemIndex) in order.order_items"
                                v-bind:key="itemIndex">
                                <p v-if="item.item_type === 'garment'">
                                    Garment:
                                    {{ item.quantity }} * 
                                    {{ item.garment_colour_size.garment.name }}
                                    {{ item.garment_colour_size.size }}
                                    {{ item.garment_colour_size.garment_colour.name }}<br />
                                    <span v-if="item.associated_design">
                                        <router-link v-bind:to="`/view-design/${item.associated_design}`">View Design</router-link>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../../axios';

export default {
    name: 'MyOrders',
    computed: {
        userName() {
            return this.$store.getters.userName;
        },
        authData() {
            return this.$store.getters.authData;
        },
    },
    data() {
        return {
            orders: [],
        };
    },
    methods: {
        getOrders() {
            axios.get(`/Users/getOrders.json?auth=${this.authData.token}&user=${this.authData.user}&cage=${this.authData.cage}`)
            .then((response) => {
                // eslint-disable-next-line
                this.orders = response.data.orders;
            });
        },
    },
    mounted() {
        this.getOrders();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyOrders.vue